export function getTimeAgo(date, language='pt-BR') {
    const updatedAtDate = new Date(date);
    const now = new Date();
    const diffMs = now - updatedAtDate;
    const diffMins = Math.floor(diffMs / (1000 * 60));
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    const diffMonths = Math.floor(diffDays / 30);
    const diffYears = Math.floor(diffDays / 365);

    const minuteLabel = language === 'pt-BR' ? 'minuto' : 'minute';
    const hourLabel = language === 'pt-BR' ? 'hora' : 'hour';
    const dayLabel = language === 'pt-BR' ? 'dia' : 'day';
    const monthLabel = language === 'pt-BR' ? 'mês' : 'month';
    const yearLabel = language === 'pt-BR' ? 'ano' : 'year';

    const monthLabelPlural = language === 'pt-BR' ? 'meses' : 'months';

    let timeAgo = '';
    if (diffMins < 60) {
        timeAgo = `${diffMins} ${minuteLabel}${diffMins !== 1 ? 's' : ''}`;
    } else if (diffHours < 24) {
        timeAgo = `${diffHours} ${hourLabel}${diffHours !== 1 ? 's' : ''}`;
    } else if (diffDays < 30) {
        timeAgo = `${diffDays} ${dayLabel}${diffDays !== 1 ? 's' : ''}`;
    } else if (diffMonths < 12) {
        timeAgo = `${diffMonths} ${diffMonths > 1 ? monthLabelPlural : monthLabel}`;
    } else {
        timeAgo = `${diffYears} ${yearLabel}${diffYears !== 1 ? 's' : ''}`;
    }

    let returnText = '';
    if (language === 'pt-BR') returnText = `${timeAgo} atrás`;   
    else returnText = `${timeAgo} ago`;   

    return returnText;
}